import { useTranslations } from 'next-intl';
import { useEffect, useRef, useState } from 'react';
import { ButtonsBar, Modal } from '@/components/base/SearchListing/components/Modal';
import { DatePickerModal } from '@/component/DateRange';
import {
  ButtonOutline,
  ButtonPrimary,
} from '@/components/base/SearchListing/components/Button';

export function DateModal({
  onClose,
  onSubmit,
  date,
  minDate,
  maxDate,
  disabledDates,
  disabledDay,
  getMinimumDays,
  getDaysRequirement,
  onDateChange,
}) {
  const t = useTranslations();
  const datePickerRef = useRef(null);
  const { height: parentHeight } = useElementHeight({
    elementRef: datePickerRef,
  });
  const disabledSubmit = !(
    date &&
    date.startDate &&
    date.endDate &&
    new Date(date.startDate).toISOString() !==
      new Date(date.endDate).toISOString()
  );

  return (
    <Modal>
      <div className="!px-4 !pt-4 sm:!px-10">
        <h3 className="text-slate-800 text-[calc(24_*_100vw_/_390)] !mx-2.5 !my-2 !mb-[calc(8_*_100vw_/_390)] font-semibold font-['Raleway'] leading-[30px] tracking-tight">
          {t('modal-mobile-date-title')}
        </h3>
        <div className="justify-content-center text-zinc-900 text-[calc(14_*_100vw_/_390)] [&>span]:leading-[calc(24_*_100vw_/_390)] [&>span]:h-[calc(24_*_100vw_/_390)] [&>span]:w-[calc(42_*_100vw_/_390)] md:text-sm font-semibold font-['Raleway'] leading-tight !mb-1 grid grid-cols-7 h-[calc(24_*_100vw_/_390)] items-center max-md:text-center max-md:px-2 mx-auto">
          <span>Mo</span>
          <span>Tu</span>
          <span>We</span>
          <span>Th</span>
          <span>Fr</span>
          <span>Sa</span>
          <span>Su</span>
        </div>
      </div>
      <div className="border-b border-slate-300" />
      <div
        className="!px-0 !pt-0 flex-1 relative overflow-x-hidden overflow-y-auto scrollbar-none"
        ref={datePickerRef}
      >
        {parentHeight !== null && (
          <DatePickerModal
            value={date}
            minDate={minDate}
            maxDate={maxDate}
            getMinimumDays={getMinimumDays}
            getDaysRequirement={getDaysRequirement}
            disabledDates={disabledDates}
            disabledDay={disabledDay}
            onChange={onDateChange}
            availableHeight={parentHeight}
          />
        )}
      </div>
      <ButtonsBar>
        <ButtonOutline onClick={onClose}>{t('action-close')}</ButtonOutline>
        <ButtonPrimary onClick={onSubmit} disabled={disabledSubmit}>
          {t('add-guests')}
        </ButtonPrimary>
      </ButtonsBar>
    </Modal>
  );
}

function useElementHeight({ elementRef }) {
  const [height, setHeight] = useState(null);
  useEffect(() => {
    if (!elementRef.current) {
      setHeight(null);
      return;
    }
    const s = getComputedStyle(elementRef.current);
    const padding = parseInt(s.paddingTop);
    const rect = elementRef.current.getBoundingClientRect();
    setHeight(rect.height - padding);
  }, []);
  return { height };
}
